import React from 'react'
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

const MapStyles = require("../utils/style-map.json");

const MAP_URL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDTxOWJy85fgKTMOCHb2Whj2aJrt3Dm3JA&v=3.exp&libraries=geometry";

const MapComponent = compose(
  withProps({
    googleMapURL: MAP_URL,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `500px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={17}
    defaultCenter={{ lat: 1.278721, lng: 103.848430 }}
    defaultOptions={{ styles: MapStyles }}
  >
    {props.isMarkerShown && <Marker position={{ lat: 1.278721, lng: 103.848430 }} />}
  </GoogleMap>
);

export default MapComponent


// WEBPACK FOOTER //
// ./src/components/map.js